import { DealVersion } from '../../types/deal.types';
import momentTz from 'moment-timezone';

export function getSaleDate(deal: DealVersion) {
  return deal.saleDate
    ? momentTz(deal.saleDate.toDate())
        .tz('America/New_York')
        .format('MM/DD/YYYY hh:mm A z')
    : null;
}
